import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import { Match, Event} from '../../models'
import camelCase from 'camelcase'
import template from './duel-results.jade'
import sources from '../../../helpers/sources'
import '../status'
import '../match-times'
import '../lineups'
import getState from '../../services/create-event'
import notify from '@scoutgg/ftw/source/services/notification'
import emitter from '@scoutgg/ftw/source/services/emitter'
import normalize from '../../../helpers/normalize'

import '@scoutgg/ftw/source/atoms/form-control/form-control'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('edit-mode', Boolean)
@Attribute('event-type', String)
export default class DuelResults extends HTMLElement {
  attached() {
    this.update(this.match.load()).then(() => {
      if(!this.events) this.events = []
    })
    this.state.listen(this, true)
  }

  get state() {
    return getState(this.match)
  }

  reset() {
    this.state.reset()
  }

  matchChange() {
    this.update(this.match.load())
    this.state.listen(this, true)
  }

  saveStats() {
    var lineups = this.match.lineups.map(lineup => {
      return {
        _id: lineup._id,
        match: lineup.matchId,
        player: lineup.playerId,
        team: lineup.teamId,
        stats: lineup.stats,
        status: lineup.status,
        duration: lineup.duration,
      }
    })

    this.match.post('lineups', {lineups})
      .then(() => {
        notify('Stats saved', {level: 'success', timeout: 3000})
        this.state.reload(true)
        emitter.emit('match-updated')
        this.editMode = false
      })
  }

  sendFeeds() {
    if(this.match.$isSubmitting) return
    this.match.post('send-feeds', {forceCalculations: true})
      .then(() => { notify('Events sent', {level: 'success', timeout: 5000}) })
      .catch((err) => {
        notify(err.message, {level: 'danger', timeout: 10000})
      })
      .then(() => this.render())
    this.render()
  }

  destroy(event) {
    if(this.isSubmittingRank) return
    this.isSubmittingRank = true
    event.$isSubmitting = true
    event.destroy().then(() => {
      this.state.reload()
      this.isSubmittingRank = false
      this.render()
    }).catch(() => {
      event.$isSubmitting = false
      this.isSubmittingRank = false
      this.render()
    })
    this.render()
  }

  canScrapeLineups(source) {
    var s = sources[source.source]
    return s && s.lineups
  }

  addWinner(lineup, type = 'won_duel') {
    if(this.isSubmittingRank) return
    this.isSubmittingRank = true
    lineup.$isSubmittingRank = true
    const teams = this.teamPairs
    const pair = teams[lineup.team]
    var event = {
      match: lineup.match._id,
      team: lineup.team._id,
      player: lineup.player._id,
      name: type,
      minute: pair * 10,
      second: 0,
    }
    if(type === 'won_duel') {
      event.player = lineup.player._id
      event.minute += lineup.stats.pair
    } else {
      event.minute += 9
    }
    this.match
      .post('events', { event })
      .catch(err => console.error(err))
      .then(() => {
        this.state.reload(true)
        this.isSubmittingRank = false
        lineup.$isSubmitting = false
      })
    this.events.push(Event.create(event))
    this.render()
  }

  isDuelWinner(lineup) {
    const { stats } = lineup
    if(!stats) return
    return stats.winQ16 ||
      stats.winQ8 ||
      stats.winQ4 ||
      stats.winFinal ||
      stats.winBronzeFinal
  }

  get teamPairs() {
    if(!this.lineups) return {}
    return this.lineups
      .filter(l => l.position === 'manager' && l.stats && l.stats.pair)
      .reduce((obj, l) => {
        obj[l.team] = l.stats.pair
        return obj
      }, {})
  }

  get pairs() {
    if(!this.lineups) return
    const managers = this.lineups
      .filter(l => l.position === 'manager' && l.stats && l.stats.pair)
    const paired = {}
    for(const l of managers) {
      const pair = l.stats.pair
      if(!paired[pair]) paired[pair] = []
      paired[pair].push(l.team)
    }

    return Object.entries(paired)
      .sort(([a], [b]) => a - b)
      .map(([pair, teams]) => [pair, teams.sort((a, b) => a.name.localeCompare(b.name))])
  }

  get duels() {
    if(!this.lineups) return
    const teams = this.teamPairs
    const teamVictories = (this.events || [])
      .filter(e => e.name === 'won_team_duel')
      .reduce((obj, e) => {
        obj[Math.floor(e.minute / 10)] = e
        return obj
      }, {})
    const victories = (this.events || [])
      .filter(e => e.name === 'won_duel')
      .reduce((obj, e) => {
        obj[e.minute] = e
        return obj
      }, {})
    var prevPair
    var prevTeamPair
    var teamObj
    var obj
    return this.lineups
      .filter(l => l.position !== 'manager' && l.stats && l.stats.pair)
      .filter(l => teams[l.team])
      .sort((a, b) => {
        const aTeamPair = teams[a.team]
        const bTeamPair = teams[b.team]
        const aPair = a.stats.pair
        const bPair = b.stats.pair
        return (
          aTeamPair - bTeamPair ||
          aPair - bPair ||
          a.team.name.localeCompare(b.team.name)
        )
      })
      .reduce((pairs, l) => {
        const teamPair = teams[l.team]
        const pair = l.stats.pair
        if(teamPair !== prevTeamPair) {
          teamObj = {
            pair: teamPair,
            event: teamVictories[teamPair],
            toResolve: !teamVictories[teamPair],
            duels: [],
          }
          pairs.push(teamObj)
          prevTeamPair = teamPair
        }
        if(pair !== prevPair) {
          obj = {
            pair: pair,
            players: [],
            event: victories[teamPair * 10 + pair],
          }
          prevPair = pair
          teamObj.duels.push(obj)
          if(!obj.event) teamObj.toResolve = false
        }
        obj.players.push(l)
        return pairs
      }, [])
  }
}
